"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { DropdownCategoryType } from '../shared.mjs';
import { getRefElement } from '../../../helpers/getRefElement.mjs';
import { withSlotScopeClasses } from '../../../helpers/scoped-slots.mjs';
import { useRef } from 'react';
import { tv } from 'tailwind-variants';
import { ComboboxContainer } from '../../ComboBoxElements/ComboboxContainer/index.mjs';
import { isClickOnEditorComponent } from '../../ComboBoxElements/Editor/helpers/clicks.mjs';
import '../../DataBuilderUI/FieldControlPanel/index.mjs';
import { ActionBar } from '../../DataBuilderUI/ActionBar.mjs';
import '../../DataBuilderUI/Cell.mjs';
import 'clsx';
import '../../DataBuilderUI/styles.module.css.mjs';
import '../../DataBuilderUI/Row.mjs';
import '../../DataBuilderUI/Title.mjs';
import { ComboBoxValueBadge } from '../Badges/ComboBoxValueBadge.mjs';
import { isDefinedValue } from '../Badges/isDefinedValue.mjs';
import { useComboBox } from '../context/use-combobox.mjs';
import { useComboBoxDropdownContext } from '../context/use-combobox-dropdown.mjs';
import { Dropdown } from '../Dropdown/Dropdown.mjs';

const badgeWrapperRecipe = tv({
  slots: withSlotScopeClasses("badge-wrapper", {
    root: "relative inline-flex max-w-full w-fit",
    "action-bar": "hidden"
  }),
  variants: {
    expanded: {
      true: {
        "action-bar": "absolute top-0 left-full bottom-0 mr-0 w-0 z-[1]"
      }
    }
  }
});
function ComboboxTagTrigger({
  placeholder,
  className,
  onChange,
  disabled,
  valueComponent,
  ...rest
}) {
  const valueRef = useRef(null);
  const fieldValueRef = useRef(null);
  const {
    refsToIgnoreClick,
    // Dropdown related
    isDropdownOpen,
    openDropdown,
    closeDropdown,
    topDropdownPanelComponent,
    value
  } = useComboBox();
  const { activeCategory } = useComboBoxDropdownContext();
  function handleOpenDropdown() {
    if (disabled) return;
    openDropdown();
  }
  const refs = [valueRef, fieldValueRef, ...refsToIgnoreClick ?? []];
  const handleClick = function handleClick2(e) {
    const isClickInsideAnyOfElements = refs.map(getRefElement).some((el) => el.contains(e?.target));
    if (isClickInsideAnyOfElements && !isClickOnEditorComponent(e?.target, fieldValueRef?.current)) {
      handleOpenDropdown();
      e?.stopPropagation();
    }
  };
  function handleOptionSelect(option) {
    const keepDropdownOpen = activeCategory && [DropdownCategoryType.SELECT_FROM_UDM_DYNAMICALLY].includes(activeCategory);
    onChange(option);
    if (!keepDropdownOpen) {
      closeDropdown();
    }
  }
  const handleOnDelete = () => {
    onChange(void 0);
    closeDropdown();
  };
  const styles = badgeWrapperRecipe({ expanded: isDropdownOpen });
  return /* @__PURE__ */ jsx(
    ComboboxContainer,
    {
      ref: fieldValueRef,
      "aria-expanded": isDropdownOpen,
      "data-tag-dropdown-open": isDropdownOpen,
      "data-selected": rest["data-selected"],
      onClick: handleClick,
      disabled,
      level: "tag",
      children: /* @__PURE__ */ jsx(
        Dropdown,
        {
          topDropdownPanelComponent,
          autoFocusOnSearch: true,
          onOptionSelect: handleOptionSelect,
          children: /* @__PURE__ */ jsx("span", { className: styles.root(), ref: valueRef, children: valueComponent ? /* @__PURE__ */ jsxs(Fragment, { children: [
            valueComponent,
            isDefinedValue(value) && /* @__PURE__ */ jsx(ActionBar, { className: styles["action-bar"](), children: /* @__PURE__ */ jsx(ActionBar.DeleteButton, { onClick: handleOnDelete }) })
          ] }) : /* @__PURE__ */ jsx(
            ComboBoxValueBadge,
            {
              className,
              placeholder,
              disabled,
              isDropdownOpen,
              onDelete: handleOnDelete
            }
          ) })
        }
      )
    }
  );
}

export { ComboboxTagTrigger };
